import { render } from "./FooterCobre.vue?vue&type=template&id=68323285&scoped=true"
import script from "./FooterCobre.vue?vue&type=script&lang=js"
export * from "./FooterCobre.vue?vue&type=script&lang=js"

import "./FooterCobre.vue?vue&type=style&index=0&id=68323285&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68323285"]])

export default __exports__